// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgDescriptorLanguage: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M22.757 9.191a4.281 4.281 0 0 0-3.052-1.27h-4.253V4.952A4.322 4.322 0 0 0 11.13.63H4.322A4.322 4.322 0 0 0 0 4.952v6.808a4.322 4.322 0 0 0 4.322 4.322h4.253v2.983a4.267 4.267 0 0 0 1.257 3.037c.389.407.86.727 1.38.94.52.22 1.08.334 1.644.33h6.821a4.267 4.267 0 0 0 3.052-1.256A4.336 4.336 0 0 0 24 19.065v-6.822a4.226 4.226 0 0 0-1.242-3.052M4.322 14.15a2.389 2.389 0 0 1-2.389-2.39V4.953a2.375 2.375 0 0 1 2.39-2.389h6.807a2.39 2.39 0 0 1 2.389 2.389v6.808a2.403 2.403 0 0 1-2.39 2.389zm17.772 4.916a2.376 2.376 0 0 1-2.389 2.375h-6.821a2.333 2.333 0 0 1-.912-.18 2.428 2.428 0 0 1-.773-.51 2.403 2.403 0 0 1-.69-1.685v-2.983h.62a4.336 4.336 0 0 0 3.605-1.933l-2.182 5.606v.11h1.754l.677-1.753h2.761l.704 1.754h1.878l-3.245-8.286h-1.284l-.373.967c.015-.24.015-.48 0-.718V9.854h4.253a2.403 2.403 0 0 1 2.417 2.389zm-6.67-2.348.553-1.712.4-1.381.428 1.38.511 1.7z" />
        <path d="m11.89 13.39.8-1.534-.262-.096a11.82 11.82 0 0 1-3.508-1.464 9.666 9.666 0 0 0 2.03-3.687h1.602V5.118H8.59l.304-.235-.207-.221a8.782 8.782 0 0 0-1.52-1.27h-.11l-.152-.166-1.215.911.304.221c.274.207.537.428.787.663l.124.097H2.762v1.491h1.67a10.743 10.743 0 0 0 2.044 3.687 9.982 9.982 0 0 1-3.618 1.464l-.345.083.801 1.532h.221a13.133 13.133 0 0 0 4.143-2.016 15.854 15.854 0 0 0 3.99 1.947zM9.251 6.61a8.285 8.285 0 0 1-1.588 2.623 7.636 7.636 0 0 1-1.588-2.624z" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgDescriptorLanguage);
export default Memo;
